var hn = typeof global == "object" && global && global.Object === Object && global;
const lr = hn;
var mn = typeof self == "object" && self && self.Object === Object && self, gn = lr || mn || Function("return this")();
const E = gn;
var bn = E.Symbol;
const O = bn;
var dr = Object.prototype, vn = dr.hasOwnProperty, yn = dr.toString, K = O ? O.toStringTag : void 0;
function wn(t) {
  var e = vn.call(t, K), r = t[K];
  try {
    t[K] = void 0;
    var n = !0;
  } catch {
  }
  var a = yn.call(t);
  return n && (e ? t[K] = r : delete t[K]), a;
}
var _n = Object.prototype, Sn = _n.toString;
function $n(t) {
  return Sn.call(t);
}
var Tn = "[object Null]", En = "[object Undefined]", me = O ? O.toStringTag : void 0;
function z(t) {
  return t == null ? t === void 0 ? En : Tn : me && me in Object(t) ? wn(t) : $n(t);
}
function G(t) {
  return t != null && typeof t == "object";
}
var Cn = "[object Symbol]";
function Kt(t) {
  return typeof t == "symbol" || G(t) && z(t) == Cn;
}
function An(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length, a = Array(n); ++r < n; )
    a[r] = e(t[r], r, t);
  return a;
}
var xn = Array.isArray;
const W = xn;
var On = 1 / 0, ge = O ? O.prototype : void 0, be = ge ? ge.toString : void 0;
function pr(t) {
  if (typeof t == "string")
    return t;
  if (W(t))
    return An(t, pr) + "";
  if (Kt(t))
    return be ? be.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -On ? "-0" : e;
}
function L(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var Pn = "[object AsyncFunction]", jn = "[object Function]", Rn = "[object GeneratorFunction]", Un = "[object Proxy]";
function fr(t) {
  if (!L(t))
    return !1;
  var e = z(t);
  return e == jn || e == Rn || e == Pn || e == Un;
}
var In = E["__core-js_shared__"];
const yt = In;
var ve = function() {
  var t = /[^.]+$/.exec(yt && yt.keys && yt.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function Ln(t) {
  return !!ve && ve in t;
}
var kn = Function.prototype, qn = kn.toString;
function q(t) {
  if (t != null) {
    try {
      return qn.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var Dn = /[\\^$.*+?()[\]{}|]/g, Nn = /^\[object .+?Constructor\]$/, Mn = Function.prototype, Fn = Object.prototype, Bn = Mn.toString, Hn = Fn.hasOwnProperty, zn = RegExp(
  "^" + Bn.call(Hn).replace(Dn, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Gn(t) {
  if (!L(t) || Ln(t))
    return !1;
  var e = fr(t) ? zn : Nn;
  return e.test(q(t));
}
function Wn(t, e) {
  return t == null ? void 0 : t[e];
}
function D(t, e) {
  var r = Wn(t, e);
  return Gn(r) ? r : void 0;
}
var Jn = D(E, "WeakMap");
const Nt = Jn;
var ye = Object.create, Kn = function() {
  function t() {
  }
  return function(e) {
    if (!L(e))
      return {};
    if (ye)
      return ye(e);
    t.prototype = e;
    var r = new t();
    return t.prototype = void 0, r;
  };
}();
const Vn = Kn;
function Xn(t, e) {
  var r = -1, n = t.length;
  for (e || (e = Array(n)); ++r < n; )
    e[r] = t[r];
  return e;
}
var Yn = function() {
  try {
    var t = D(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
}();
const we = Yn;
function Zn(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length; ++r < n && e(t[r], r, t) !== !1; )
    ;
  return t;
}
var Qn = 9007199254740991, ta = /^(?:0|[1-9]\d*)$/;
function hr(t, e) {
  var r = typeof t;
  return e = e == null ? Qn : e, !!e && (r == "number" || r != "symbol" && ta.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
function mr(t, e, r) {
  e == "__proto__" && we ? we(t, e, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : t[e] = r;
}
function gr(t, e) {
  return t === e || t !== t && e !== e;
}
var ea = Object.prototype, ra = ea.hasOwnProperty;
function Vt(t, e, r) {
  var n = t[e];
  (!(ra.call(t, e) && gr(n, r)) || r === void 0 && !(e in t)) && mr(t, e, r);
}
function lt(t, e, r, n) {
  var a = !r;
  r || (r = {});
  for (var s = -1, o = e.length; ++s < o; ) {
    var i = e[s], u = n ? n(r[i], t[i], i, r, t) : void 0;
    u === void 0 && (u = t[i]), a ? mr(r, i, u) : Vt(r, i, u);
  }
  return r;
}
var na = 9007199254740991;
function br(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= na;
}
function vr(t) {
  return t != null && br(t.length) && !fr(t);
}
var aa = Object.prototype;
function Xt(t) {
  var e = t && t.constructor, r = typeof e == "function" && e.prototype || aa;
  return t === r;
}
function sa(t, e) {
  for (var r = -1, n = Array(t); ++r < t; )
    n[r] = e(r);
  return n;
}
var ia = "[object Arguments]";
function _e(t) {
  return G(t) && z(t) == ia;
}
var yr = Object.prototype, oa = yr.hasOwnProperty, ca = yr.propertyIsEnumerable, ua = _e(function() {
  return arguments;
}()) ? _e : function(t) {
  return G(t) && oa.call(t, "callee") && !ca.call(t, "callee");
};
const la = ua;
function da() {
  return !1;
}
var wr = typeof exports == "object" && exports && !exports.nodeType && exports, Se = wr && typeof module == "object" && module && !module.nodeType && module, pa = Se && Se.exports === wr, $e = pa ? E.Buffer : void 0, fa = $e ? $e.isBuffer : void 0, ha = fa || da;
const _r = ha;
var ma = "[object Arguments]", ga = "[object Array]", ba = "[object Boolean]", va = "[object Date]", ya = "[object Error]", wa = "[object Function]", _a = "[object Map]", Sa = "[object Number]", $a = "[object Object]", Ta = "[object RegExp]", Ea = "[object Set]", Ca = "[object String]", Aa = "[object WeakMap]", xa = "[object ArrayBuffer]", Oa = "[object DataView]", Pa = "[object Float32Array]", ja = "[object Float64Array]", Ra = "[object Int8Array]", Ua = "[object Int16Array]", Ia = "[object Int32Array]", La = "[object Uint8Array]", ka = "[object Uint8ClampedArray]", qa = "[object Uint16Array]", Da = "[object Uint32Array]", m = {};
m[Pa] = m[ja] = m[Ra] = m[Ua] = m[Ia] = m[La] = m[ka] = m[qa] = m[Da] = !0;
m[ma] = m[ga] = m[xa] = m[ba] = m[Oa] = m[va] = m[ya] = m[wa] = m[_a] = m[Sa] = m[$a] = m[Ta] = m[Ea] = m[Ca] = m[Aa] = !1;
function Na(t) {
  return G(t) && br(t.length) && !!m[z(t)];
}
function Yt(t) {
  return function(e) {
    return t(e);
  };
}
var Sr = typeof exports == "object" && exports && !exports.nodeType && exports, Z = Sr && typeof module == "object" && module && !module.nodeType && module, Ma = Z && Z.exports === Sr, wt = Ma && lr.process, Fa = function() {
  try {
    var t = Z && Z.require && Z.require("util").types;
    return t || wt && wt.binding && wt.binding("util");
  } catch {
  }
}();
const H = Fa;
var Te = H && H.isTypedArray, Ba = Te ? Yt(Te) : Na;
const Ha = Ba;
var za = Object.prototype, Ga = za.hasOwnProperty;
function $r(t, e) {
  var r = W(t), n = !r && la(t), a = !r && !n && _r(t), s = !r && !n && !a && Ha(t), o = r || n || a || s, i = o ? sa(t.length, String) : [], u = i.length;
  for (var l in t)
    (e || Ga.call(t, l)) && !(o && (l == "length" || a && (l == "offset" || l == "parent") || s && (l == "buffer" || l == "byteLength" || l == "byteOffset") || hr(l, u))) && i.push(l);
  return i;
}
function Tr(t, e) {
  return function(r) {
    return t(e(r));
  };
}
var Wa = Tr(Object.keys, Object);
const Ja = Wa;
var Ka = Object.prototype, Va = Ka.hasOwnProperty;
function Xa(t) {
  if (!Xt(t))
    return Ja(t);
  var e = [];
  for (var r in Object(t))
    Va.call(t, r) && r != "constructor" && e.push(r);
  return e;
}
function Zt(t) {
  return vr(t) ? $r(t) : Xa(t);
}
function Ya(t) {
  var e = [];
  if (t != null)
    for (var r in Object(t))
      e.push(r);
  return e;
}
var Za = Object.prototype, Qa = Za.hasOwnProperty;
function ts(t) {
  if (!L(t))
    return Ya(t);
  var e = Xt(t), r = [];
  for (var n in t)
    n == "constructor" && (e || !Qa.call(t, n)) || r.push(n);
  return r;
}
function Qt(t) {
  return vr(t) ? $r(t, !0) : ts(t);
}
var es = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, rs = /^\w*$/;
function ns(t, e) {
  if (W(t))
    return !1;
  var r = typeof t;
  return r == "number" || r == "symbol" || r == "boolean" || t == null || Kt(t) ? !0 : rs.test(t) || !es.test(t) || e != null && t in Object(e);
}
var as = D(Object, "create");
const tt = as;
function ss() {
  this.__data__ = tt ? tt(null) : {}, this.size = 0;
}
function is(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var os = "__lodash_hash_undefined__", cs = Object.prototype, us = cs.hasOwnProperty;
function ls(t) {
  var e = this.__data__;
  if (tt) {
    var r = e[t];
    return r === os ? void 0 : r;
  }
  return us.call(e, t) ? e[t] : void 0;
}
var ds = Object.prototype, ps = ds.hasOwnProperty;
function fs(t) {
  var e = this.__data__;
  return tt ? e[t] !== void 0 : ps.call(e, t);
}
var hs = "__lodash_hash_undefined__";
function ms(t, e) {
  var r = this.__data__;
  return this.size += this.has(t) ? 0 : 1, r[t] = tt && e === void 0 ? hs : e, this;
}
function k(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
k.prototype.clear = ss;
k.prototype.delete = is;
k.prototype.get = ls;
k.prototype.has = fs;
k.prototype.set = ms;
function gs() {
  this.__data__ = [], this.size = 0;
}
function dt(t, e) {
  for (var r = t.length; r--; )
    if (gr(t[r][0], e))
      return r;
  return -1;
}
var bs = Array.prototype, vs = bs.splice;
function ys(t) {
  var e = this.__data__, r = dt(e, t);
  if (r < 0)
    return !1;
  var n = e.length - 1;
  return r == n ? e.pop() : vs.call(e, r, 1), --this.size, !0;
}
function ws(t) {
  var e = this.__data__, r = dt(e, t);
  return r < 0 ? void 0 : e[r][1];
}
function _s(t) {
  return dt(this.__data__, t) > -1;
}
function Ss(t, e) {
  var r = this.__data__, n = dt(r, t);
  return n < 0 ? (++this.size, r.push([t, e])) : r[n][1] = e, this;
}
function A(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
A.prototype.clear = gs;
A.prototype.delete = ys;
A.prototype.get = ws;
A.prototype.has = _s;
A.prototype.set = Ss;
var $s = D(E, "Map");
const et = $s;
function Ts() {
  this.size = 0, this.__data__ = {
    hash: new k(),
    map: new (et || A)(),
    string: new k()
  };
}
function Es(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
function pt(t, e) {
  var r = t.__data__;
  return Es(e) ? r[typeof e == "string" ? "string" : "hash"] : r.map;
}
function Cs(t) {
  var e = pt(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
function As(t) {
  return pt(this, t).get(t);
}
function xs(t) {
  return pt(this, t).has(t);
}
function Os(t, e) {
  var r = pt(this, t), n = r.size;
  return r.set(t, e), this.size += r.size == n ? 0 : 1, this;
}
function P(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
P.prototype.clear = Ts;
P.prototype.delete = Cs;
P.prototype.get = As;
P.prototype.has = xs;
P.prototype.set = Os;
var Ps = "Expected a function";
function te(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError(Ps);
  var r = function() {
    var n = arguments, a = e ? e.apply(this, n) : n[0], s = r.cache;
    if (s.has(a))
      return s.get(a);
    var o = t.apply(this, n);
    return r.cache = s.set(a, o) || s, o;
  };
  return r.cache = new (te.Cache || P)(), r;
}
te.Cache = P;
var js = 500;
function Rs(t) {
  var e = te(t, function(n) {
    return r.size === js && r.clear(), n;
  }), r = e.cache;
  return e;
}
var Us = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Is = /\\(\\)?/g, Ls = Rs(function(t) {
  var e = [];
  return t.charCodeAt(0) === 46 && e.push(""), t.replace(Us, function(r, n, a, s) {
    e.push(a ? s.replace(Is, "$1") : n || r);
  }), e;
});
const ks = Ls;
function qs(t) {
  return t == null ? "" : pr(t);
}
function Er(t, e) {
  return W(t) ? t : ns(t, e) ? [t] : ks(qs(t));
}
var Ds = 1 / 0;
function Cr(t) {
  if (typeof t == "string" || Kt(t))
    return t;
  var e = t + "";
  return e == "0" && 1 / t == -Ds ? "-0" : e;
}
function Ns(t, e) {
  e = Er(e, t);
  for (var r = 0, n = e.length; t != null && r < n; )
    t = t[Cr(e[r++])];
  return r && r == n ? t : void 0;
}
function Ms(t, e, r) {
  var n = t == null ? void 0 : Ns(t, e);
  return n === void 0 ? r : n;
}
function Ar(t, e) {
  for (var r = -1, n = e.length, a = t.length; ++r < n; )
    t[a + r] = e[r];
  return t;
}
var Fs = Tr(Object.getPrototypeOf, Object);
const xr = Fs;
function Bs() {
  this.__data__ = new A(), this.size = 0;
}
function Hs(t) {
  var e = this.__data__, r = e.delete(t);
  return this.size = e.size, r;
}
function zs(t) {
  return this.__data__.get(t);
}
function Gs(t) {
  return this.__data__.has(t);
}
var Ws = 200;
function Js(t, e) {
  var r = this.__data__;
  if (r instanceof A) {
    var n = r.__data__;
    if (!et || n.length < Ws - 1)
      return n.push([t, e]), this.size = ++r.size, this;
    r = this.__data__ = new P(n);
  }
  return r.set(t, e), this.size = r.size, this;
}
function J(t) {
  var e = this.__data__ = new A(t);
  this.size = e.size;
}
J.prototype.clear = Bs;
J.prototype.delete = Hs;
J.prototype.get = zs;
J.prototype.has = Gs;
J.prototype.set = Js;
function Ks(t, e) {
  return t && lt(e, Zt(e), t);
}
function Vs(t, e) {
  return t && lt(e, Qt(e), t);
}
var Or = typeof exports == "object" && exports && !exports.nodeType && exports, Ee = Or && typeof module == "object" && module && !module.nodeType && module, Xs = Ee && Ee.exports === Or, Ce = Xs ? E.Buffer : void 0, Ae = Ce ? Ce.allocUnsafe : void 0;
function Ys(t, e) {
  if (e)
    return t.slice();
  var r = t.length, n = Ae ? Ae(r) : new t.constructor(r);
  return t.copy(n), n;
}
function Zs(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length, a = 0, s = []; ++r < n; ) {
    var o = t[r];
    e(o, r, t) && (s[a++] = o);
  }
  return s;
}
function Pr() {
  return [];
}
var Qs = Object.prototype, ti = Qs.propertyIsEnumerable, xe = Object.getOwnPropertySymbols, ei = xe ? function(t) {
  return t == null ? [] : (t = Object(t), Zs(xe(t), function(e) {
    return ti.call(t, e);
  }));
} : Pr;
const ee = ei;
function ri(t, e) {
  return lt(t, ee(t), e);
}
var ni = Object.getOwnPropertySymbols, ai = ni ? function(t) {
  for (var e = []; t; )
    Ar(e, ee(t)), t = xr(t);
  return e;
} : Pr;
const jr = ai;
function si(t, e) {
  return lt(t, jr(t), e);
}
function Rr(t, e, r) {
  var n = e(t);
  return W(t) ? n : Ar(n, r(t));
}
function ii(t) {
  return Rr(t, Zt, ee);
}
function oi(t) {
  return Rr(t, Qt, jr);
}
var ci = D(E, "DataView");
const Mt = ci;
var ui = D(E, "Promise");
const Ft = ui;
var li = D(E, "Set");
const Bt = li;
var Oe = "[object Map]", di = "[object Object]", Pe = "[object Promise]", je = "[object Set]", Re = "[object WeakMap]", Ue = "[object DataView]", pi = q(Mt), fi = q(et), hi = q(Ft), mi = q(Bt), gi = q(Nt), I = z;
(Mt && I(new Mt(new ArrayBuffer(1))) != Ue || et && I(new et()) != Oe || Ft && I(Ft.resolve()) != Pe || Bt && I(new Bt()) != je || Nt && I(new Nt()) != Re) && (I = function(t) {
  var e = z(t), r = e == di ? t.constructor : void 0, n = r ? q(r) : "";
  if (n)
    switch (n) {
      case pi:
        return Ue;
      case fi:
        return Oe;
      case hi:
        return Pe;
      case mi:
        return je;
      case gi:
        return Re;
    }
  return e;
});
const re = I;
var bi = Object.prototype, vi = bi.hasOwnProperty;
function yi(t) {
  var e = t.length, r = new t.constructor(e);
  return e && typeof t[0] == "string" && vi.call(t, "index") && (r.index = t.index, r.input = t.input), r;
}
var wi = E.Uint8Array;
const Ie = wi;
function ne(t) {
  var e = new t.constructor(t.byteLength);
  return new Ie(e).set(new Ie(t)), e;
}
function _i(t, e) {
  var r = e ? ne(t.buffer) : t.buffer;
  return new t.constructor(r, t.byteOffset, t.byteLength);
}
var Si = /\w*$/;
function $i(t) {
  var e = new t.constructor(t.source, Si.exec(t));
  return e.lastIndex = t.lastIndex, e;
}
var Le = O ? O.prototype : void 0, ke = Le ? Le.valueOf : void 0;
function Ti(t) {
  return ke ? Object(ke.call(t)) : {};
}
function Ei(t, e) {
  var r = e ? ne(t.buffer) : t.buffer;
  return new t.constructor(r, t.byteOffset, t.length);
}
var Ci = "[object Boolean]", Ai = "[object Date]", xi = "[object Map]", Oi = "[object Number]", Pi = "[object RegExp]", ji = "[object Set]", Ri = "[object String]", Ui = "[object Symbol]", Ii = "[object ArrayBuffer]", Li = "[object DataView]", ki = "[object Float32Array]", qi = "[object Float64Array]", Di = "[object Int8Array]", Ni = "[object Int16Array]", Mi = "[object Int32Array]", Fi = "[object Uint8Array]", Bi = "[object Uint8ClampedArray]", Hi = "[object Uint16Array]", zi = "[object Uint32Array]";
function Gi(t, e, r) {
  var n = t.constructor;
  switch (e) {
    case Ii:
      return ne(t);
    case Ci:
    case Ai:
      return new n(+t);
    case Li:
      return _i(t, r);
    case ki:
    case qi:
    case Di:
    case Ni:
    case Mi:
    case Fi:
    case Bi:
    case Hi:
    case zi:
      return Ei(t, r);
    case xi:
      return new n();
    case Oi:
    case Ri:
      return new n(t);
    case Pi:
      return $i(t);
    case ji:
      return new n();
    case Ui:
      return Ti(t);
  }
}
function Wi(t) {
  return typeof t.constructor == "function" && !Xt(t) ? Vn(xr(t)) : {};
}
var Ji = "[object Map]";
function Ki(t) {
  return G(t) && re(t) == Ji;
}
var qe = H && H.isMap, Vi = qe ? Yt(qe) : Ki;
const Xi = Vi;
var Yi = "[object Set]";
function Zi(t) {
  return G(t) && re(t) == Yi;
}
var De = H && H.isSet, Qi = De ? Yt(De) : Zi;
const to = Qi;
var eo = 1, ro = 2, no = 4, Ur = "[object Arguments]", ao = "[object Array]", so = "[object Boolean]", io = "[object Date]", oo = "[object Error]", Ir = "[object Function]", co = "[object GeneratorFunction]", uo = "[object Map]", lo = "[object Number]", Lr = "[object Object]", po = "[object RegExp]", fo = "[object Set]", ho = "[object String]", mo = "[object Symbol]", go = "[object WeakMap]", bo = "[object ArrayBuffer]", vo = "[object DataView]", yo = "[object Float32Array]", wo = "[object Float64Array]", _o = "[object Int8Array]", So = "[object Int16Array]", $o = "[object Int32Array]", To = "[object Uint8Array]", Eo = "[object Uint8ClampedArray]", Co = "[object Uint16Array]", Ao = "[object Uint32Array]", h = {};
h[Ur] = h[ao] = h[bo] = h[vo] = h[so] = h[io] = h[yo] = h[wo] = h[_o] = h[So] = h[$o] = h[uo] = h[lo] = h[Lr] = h[po] = h[fo] = h[ho] = h[mo] = h[To] = h[Eo] = h[Co] = h[Ao] = !0;
h[oo] = h[Ir] = h[go] = !1;
function ot(t, e, r, n, a, s) {
  var o, i = e & eo, u = e & ro, l = e & no;
  if (r && (o = a ? r(t, n, a, s) : r(t)), o !== void 0)
    return o;
  if (!L(t))
    return t;
  var d = W(t);
  if (d) {
    if (o = yi(t), !i)
      return Xn(t, o);
  } else {
    var c = re(t), y = c == Ir || c == co;
    if (_r(t))
      return Ys(t, i);
    if (c == Lr || c == Ur || y && !a) {
      if (o = u || y ? {} : Wi(t), !i)
        return u ? si(t, Vs(o, t)) : ri(t, Ks(o, t));
    } else {
      if (!h[c])
        return a ? t : {};
      o = Gi(t, c, i);
    }
  }
  s || (s = new J());
  var f = s.get(t);
  if (f)
    return f;
  s.set(t, o), to(t) ? t.forEach(function(g) {
    o.add(ot(g, e, r, g, t, s));
  }) : Xi(t) && t.forEach(function(g, v) {
    o.set(v, ot(g, e, r, v, t, s));
  });
  var $ = l ? u ? oi : ii : u ? Qt : Zt, T = d ? void 0 : $(t);
  return Zn(T || t, function(g, v) {
    T && (v = g, g = t[v]), Vt(o, v, ot(g, e, r, v, t, s));
  }), o;
}
var xo = 1, Oo = 4;
function Ne(t) {
  return ot(t, xo | Oo);
}
function Po(t, e, r, n) {
  if (!L(t))
    return t;
  e = Er(e, t);
  for (var a = -1, s = e.length, o = s - 1, i = t; i != null && ++a < s; ) {
    var u = Cr(e[a]), l = r;
    if (u === "__proto__" || u === "constructor" || u === "prototype")
      return t;
    if (a != o) {
      var d = i[u];
      l = n ? n(d, u, i) : void 0, l === void 0 && (l = L(d) ? d : hr(e[a + 1]) ? [] : {});
    }
    Vt(i, u, l), i = i[u];
  }
  return t;
}
function jo(t, e, r) {
  return t == null ? t : Po(t, e, r);
}
const _t = {
  development: {
    httpClient: "axios",
    links: {
      terms: "http://streamlabs.site/terms",
      privacy: "http://streamlabs.site/privacy",
      ultra: "http://streamlabs.site/ultra",
      mevo: {
        terms: "https://www.mevo.com/pages/terms",
        privacy: "https://www.mevo.com/pages/privacy"
      }
    },
    services: {
      auth: {
        domain: "http://api-id.streamlabs.site",
        version: "v1"
      },
      user: {
        domain: "http://api-id.streamlabs.site",
        version: "v1"
      },
      data: {
        domain: "http://api-id.streamlabs.site",
        version: "v1"
      },
      identity: {
        domain: "http://api-id.streamlabs.site",
        version: "v1",
        pk: "please_set_this"
      }
    },
    domains: {
      identity: "https://id.streamlabs.dev",
      ultra: "https://ultra.streamlabs.dev"
    }
  },
  stage1: {
    httpClient: "axios",
    links: {
      terms: "https://stage1.streamlabs.com/terms",
      privacy: "https://stage1.streamlabs.com/privacy",
      ultra: "https://stage1.streamlabs.com/ultra",
      mevo: {
        terms: "https://www.mevo.com/pages/terms",
        privacy: "https://www.mevo.com/pages/privacy"
      }
    },
    services: {
      auth: {
        domain: "https://api-id.streamlabs.dev",
        version: "v1"
      },
      data: {
        domain: "https://api-id.streamlabs.dev",
        version: "v1"
      },
      user: {
        domain: "https://api-id.streamlabs.dev",
        version: "v1"
      },
      identity: {
        domain: "https://api-id.streamlabs.dev",
        version: "v1",
        pk: "please_set_this"
      }
    },
    domains: {
      identity: "https://id.streamlabs.dev",
      ultra: "https://ultra.streamlabs.dev"
    }
  },
  production: {
    httpClient: "axios",
    links: {
      terms: "https://streamlabs.com/terms",
      privacy: "https://streamlabs.com/privacy",
      ultra: "https://streamlabs.com/ultra",
      mevo: {
        terms: "https://www.mevo.com/pages/terms",
        privacy: "https://www.mevo.com/pages/privacy"
      }
    },
    services: {
      auth: {
        domain: "https://api-id.streamlabs.com",
        version: "v1"
      },
      data: {
        domain: "https://api-id.streamlabs.com",
        version: "v1"
      },
      user: {
        domain: "https://api-id.streamlabs.com",
        version: "v1"
      },
      identity: {
        domain: "https://api-id.streamlabs.com",
        version: "v1",
        pk: "please_set_this"
      }
    },
    domains: {
      identity: "https://id.streamlabs.com",
      ultra: "https://ultra.streamlabs.com"
    }
  }
};
function kr(t, e) {
  return Object.entries(e).forEach(([r, n]) => {
    n !== void 0 && (typeof n == "object" && n !== null ? t = {
      ...t,
      [r]: kr(
        typeof t[r] == "object" ? t[r] : {},
        n
      )
    } : t = { ...t, [r]: n });
  }), t;
}
class Ro {
  constructor(e, r = {}) {
    _t[e] || console.warn(
      "Unrecognized environment",
      e,
      "defaulting to production"
    );
    const n = kr(
      Ne(_t[e] || _t.production),
      r
    );
    this.env = e, this.data = n;
  }
  get(e = null, r = void 0) {
    return e === null ? Ne(this.data) : Ms(this.data, e, r);
  }
  set(e, r = null) {
    jo(this.data, e, r);
  }
}
let Q;
const qr = (t, e = {}) => (process.env.NODE_ENV === "development" && Q && Q.env === t && console.warn("Duplicate environment loaded"), Q = new Ro(t, e)), rt = () => {
  if (Q)
    return Q;
  throw new Error("Environment has not been initialized for key");
};
function Uo(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Dr = { exports: {} }, ae = { exports: {} }, Nr = function(e, r) {
  return function() {
    for (var a = new Array(arguments.length), s = 0; s < a.length; s++)
      a[s] = arguments[s];
    return e.apply(r, a);
  };
}, Io = Nr, j = Object.prototype.toString;
function se(t) {
  return Array.isArray(t);
}
function Ht(t) {
  return typeof t > "u";
}
function Lo(t) {
  return t !== null && !Ht(t) && t.constructor !== null && !Ht(t.constructor) && typeof t.constructor.isBuffer == "function" && t.constructor.isBuffer(t);
}
function Mr(t) {
  return j.call(t) === "[object ArrayBuffer]";
}
function ko(t) {
  return j.call(t) === "[object FormData]";
}
function qo(t) {
  var e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t) : e = t && t.buffer && Mr(t.buffer), e;
}
function Do(t) {
  return typeof t == "string";
}
function No(t) {
  return typeof t == "number";
}
function Fr(t) {
  return t !== null && typeof t == "object";
}
function ct(t) {
  if (j.call(t) !== "[object Object]")
    return !1;
  var e = Object.getPrototypeOf(t);
  return e === null || e === Object.prototype;
}
function Mo(t) {
  return j.call(t) === "[object Date]";
}
function Fo(t) {
  return j.call(t) === "[object File]";
}
function Bo(t) {
  return j.call(t) === "[object Blob]";
}
function Br(t) {
  return j.call(t) === "[object Function]";
}
function Ho(t) {
  return Fr(t) && Br(t.pipe);
}
function zo(t) {
  return j.call(t) === "[object URLSearchParams]";
}
function Go(t) {
  return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
}
function Wo() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function ie(t, e) {
  if (!(t === null || typeof t > "u"))
    if (typeof t != "object" && (t = [t]), se(t))
      for (var r = 0, n = t.length; r < n; r++)
        e.call(null, t[r], r, t);
    else
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && e.call(null, t[a], a, t);
}
function zt() {
  var t = {};
  function e(a, s) {
    ct(t[s]) && ct(a) ? t[s] = zt(t[s], a) : ct(a) ? t[s] = zt({}, a) : se(a) ? t[s] = a.slice() : t[s] = a;
  }
  for (var r = 0, n = arguments.length; r < n; r++)
    ie(arguments[r], e);
  return t;
}
function Jo(t, e, r) {
  return ie(e, function(a, s) {
    r && typeof a == "function" ? t[s] = Io(a, r) : t[s] = a;
  }), t;
}
function Ko(t) {
  return t.charCodeAt(0) === 65279 && (t = t.slice(1)), t;
}
var w = {
  isArray: se,
  isArrayBuffer: Mr,
  isBuffer: Lo,
  isFormData: ko,
  isArrayBufferView: qo,
  isString: Do,
  isNumber: No,
  isObject: Fr,
  isPlainObject: ct,
  isUndefined: Ht,
  isDate: Mo,
  isFile: Fo,
  isBlob: Bo,
  isFunction: Br,
  isStream: Ho,
  isURLSearchParams: zo,
  isStandardBrowserEnv: Wo,
  forEach: ie,
  merge: zt,
  extend: Jo,
  trim: Go,
  stripBOM: Ko
}, F = w;
function Me(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var Hr = function(e, r, n) {
  if (!r)
    return e;
  var a;
  if (n)
    a = n(r);
  else if (F.isURLSearchParams(r))
    a = r.toString();
  else {
    var s = [];
    F.forEach(r, function(u, l) {
      u === null || typeof u > "u" || (F.isArray(u) ? l = l + "[]" : u = [u], F.forEach(u, function(c) {
        F.isDate(c) ? c = c.toISOString() : F.isObject(c) && (c = JSON.stringify(c)), s.push(Me(l) + "=" + Me(c));
      }));
    }), a = s.join("&");
  }
  if (a) {
    var o = e.indexOf("#");
    o !== -1 && (e = e.slice(0, o)), e += (e.indexOf("?") === -1 ? "?" : "&") + a;
  }
  return e;
}, Vo = w;
function ft() {
  this.handlers = [];
}
ft.prototype.use = function(e, r, n) {
  return this.handlers.push({
    fulfilled: e,
    rejected: r,
    synchronous: n ? n.synchronous : !1,
    runWhen: n ? n.runWhen : null
  }), this.handlers.length - 1;
};
ft.prototype.eject = function(e) {
  this.handlers[e] && (this.handlers[e] = null);
};
ft.prototype.forEach = function(e) {
  Vo.forEach(this.handlers, function(n) {
    n !== null && e(n);
  });
};
var Xo = ft, Yo = w, Zo = function(e, r) {
  Yo.forEach(e, function(a, s) {
    s !== r && s.toUpperCase() === r.toUpperCase() && (e[r] = a, delete e[s]);
  });
}, zr = function(e, r, n, a, s) {
  return e.config = r, n && (e.code = n), e.request = a, e.response = s, e.isAxiosError = !0, e.toJSON = function() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }, e;
}, Gr = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, St, Fe;
function Wr() {
  if (Fe)
    return St;
  Fe = 1;
  var t = zr;
  return St = function(r, n, a, s, o) {
    var i = new Error(r);
    return t(i, n, a, s, o);
  }, St;
}
var $t, Be;
function Qo() {
  if (Be)
    return $t;
  Be = 1;
  var t = Wr();
  return $t = function(r, n, a) {
    var s = a.config.validateStatus;
    !a.status || !s || s(a.status) ? r(a) : n(t(
      "Request failed with status code " + a.status,
      a.config,
      null,
      a.request,
      a
    ));
  }, $t;
}
var Tt, He;
function tc() {
  if (He)
    return Tt;
  He = 1;
  var t = w;
  return Tt = t.isStandardBrowserEnv() ? function() {
    return {
      write: function(n, a, s, o, i, u) {
        var l = [];
        l.push(n + "=" + encodeURIComponent(a)), t.isNumber(s) && l.push("expires=" + new Date(s).toGMTString()), t.isString(o) && l.push("path=" + o), t.isString(i) && l.push("domain=" + i), u === !0 && l.push("secure"), document.cookie = l.join("; ");
      },
      read: function(n) {
        var a = document.cookie.match(new RegExp("(^|;\\s*)(" + n + ")=([^;]*)"));
        return a ? decodeURIComponent(a[3]) : null;
      },
      remove: function(n) {
        this.write(n, "", Date.now() - 864e5);
      }
    };
  }() : function() {
    return {
      write: function() {
      },
      read: function() {
        return null;
      },
      remove: function() {
      }
    };
  }(), Tt;
}
var Et, ze;
function ec() {
  return ze || (ze = 1, Et = function(e) {
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
  }), Et;
}
var Ct, Ge;
function rc() {
  return Ge || (Ge = 1, Ct = function(e, r) {
    return r ? e.replace(/\/+$/, "") + "/" + r.replace(/^\/+/, "") : e;
  }), Ct;
}
var At, We;
function nc() {
  if (We)
    return At;
  We = 1;
  var t = ec(), e = rc();
  return At = function(n, a) {
    return n && !t(a) ? e(n, a) : a;
  }, At;
}
var xt, Je;
function ac() {
  if (Je)
    return xt;
  Je = 1;
  var t = w, e = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return xt = function(n) {
    var a = {}, s, o, i;
    return n && t.forEach(n.split(`
`), function(l) {
      if (i = l.indexOf(":"), s = t.trim(l.substr(0, i)).toLowerCase(), o = t.trim(l.substr(i + 1)), s) {
        if (a[s] && e.indexOf(s) >= 0)
          return;
        s === "set-cookie" ? a[s] = (a[s] ? a[s] : []).concat([o]) : a[s] = a[s] ? a[s] + ", " + o : o;
      }
    }), a;
  }, xt;
}
var Ot, Ke;
function sc() {
  if (Ke)
    return Ot;
  Ke = 1;
  var t = w;
  return Ot = t.isStandardBrowserEnv() ? function() {
    var r = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a"), a;
    function s(o) {
      var i = o;
      return r && (n.setAttribute("href", i), i = n.href), n.setAttribute("href", i), {
        href: n.href,
        protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
        host: n.host,
        search: n.search ? n.search.replace(/^\?/, "") : "",
        hash: n.hash ? n.hash.replace(/^#/, "") : "",
        hostname: n.hostname,
        port: n.port,
        pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
      };
    }
    return a = s(window.location.href), function(i) {
      var u = t.isString(i) ? s(i) : i;
      return u.protocol === a.protocol && u.host === a.host;
    };
  }() : function() {
    return function() {
      return !0;
    };
  }(), Ot;
}
var Pt, Ve;
function ht() {
  if (Ve)
    return Pt;
  Ve = 1;
  function t(e) {
    this.message = e;
  }
  return t.prototype.toString = function() {
    return "Cancel" + (this.message ? ": " + this.message : "");
  }, t.prototype.__CANCEL__ = !0, Pt = t, Pt;
}
var jt, Xe;
function Ye() {
  if (Xe)
    return jt;
  Xe = 1;
  var t = w, e = Qo(), r = tc(), n = Hr, a = nc(), s = ac(), o = sc(), i = Wr(), u = Gr, l = ht();
  return jt = function(c) {
    return new Promise(function(f, $) {
      var T = c.data, g = c.headers, v = c.responseType, N;
      function de() {
        c.cancelToken && c.cancelToken.unsubscribe(N), c.signal && c.signal.removeEventListener("abort", N);
      }
      t.isFormData(T) && delete g["Content-Type"];
      var p = new XMLHttpRequest();
      if (c.auth) {
        var dn = c.auth.username || "", pn = c.auth.password ? unescape(encodeURIComponent(c.auth.password)) : "";
        g.Authorization = "Basic " + btoa(dn + ":" + pn);
      }
      var pe = a(c.baseURL, c.url);
      p.open(c.method.toUpperCase(), n(pe, c.params, c.paramsSerializer), !0), p.timeout = c.timeout;
      function fe() {
        if (!!p) {
          var S = "getAllResponseHeaders" in p ? s(p.getAllResponseHeaders()) : null, M = !v || v === "text" || v === "json" ? p.responseText : p.response, U = {
            data: M,
            status: p.status,
            statusText: p.statusText,
            headers: S,
            config: c,
            request: p
          };
          e(function(vt) {
            f(vt), de();
          }, function(vt) {
            $(vt), de();
          }, U), p = null;
        }
      }
      if ("onloadend" in p ? p.onloadend = fe : p.onreadystatechange = function() {
        !p || p.readyState !== 4 || p.status === 0 && !(p.responseURL && p.responseURL.indexOf("file:") === 0) || setTimeout(fe);
      }, p.onabort = function() {
        !p || ($(i("Request aborted", c, "ECONNABORTED", p)), p = null);
      }, p.onerror = function() {
        $(i("Network Error", c, null, p)), p = null;
      }, p.ontimeout = function() {
        var M = c.timeout ? "timeout of " + c.timeout + "ms exceeded" : "timeout exceeded", U = c.transitional || u;
        c.timeoutErrorMessage && (M = c.timeoutErrorMessage), $(i(
          M,
          c,
          U.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
          p
        )), p = null;
      }, t.isStandardBrowserEnv()) {
        var he = (c.withCredentials || o(pe)) && c.xsrfCookieName ? r.read(c.xsrfCookieName) : void 0;
        he && (g[c.xsrfHeaderName] = he);
      }
      "setRequestHeader" in p && t.forEach(g, function(M, U) {
        typeof T > "u" && U.toLowerCase() === "content-type" ? delete g[U] : p.setRequestHeader(U, M);
      }), t.isUndefined(c.withCredentials) || (p.withCredentials = !!c.withCredentials), v && v !== "json" && (p.responseType = c.responseType), typeof c.onDownloadProgress == "function" && p.addEventListener("progress", c.onDownloadProgress), typeof c.onUploadProgress == "function" && p.upload && p.upload.addEventListener("progress", c.onUploadProgress), (c.cancelToken || c.signal) && (N = function(S) {
        !p || ($(!S || S && S.type ? new l("canceled") : S), p.abort(), p = null);
      }, c.cancelToken && c.cancelToken.subscribe(N), c.signal && (c.signal.aborted ? N() : c.signal.addEventListener("abort", N))), T || (T = null), p.send(T);
    });
  }, jt;
}
var b = w, Ze = Zo, ic = zr, oc = Gr, cc = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function Qe(t, e) {
  !b.isUndefined(t) && b.isUndefined(t["Content-Type"]) && (t["Content-Type"] = e);
}
function uc() {
  var t;
  return (typeof XMLHttpRequest < "u" || typeof process < "u" && Object.prototype.toString.call(process) === "[object process]") && (t = Ye()), t;
}
function lc(t, e, r) {
  if (b.isString(t))
    try {
      return (e || JSON.parse)(t), b.trim(t);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (r || JSON.stringify)(t);
}
var mt = {
  transitional: oc,
  adapter: uc(),
  transformRequest: [function(e, r) {
    return Ze(r, "Accept"), Ze(r, "Content-Type"), b.isFormData(e) || b.isArrayBuffer(e) || b.isBuffer(e) || b.isStream(e) || b.isFile(e) || b.isBlob(e) ? e : b.isArrayBufferView(e) ? e.buffer : b.isURLSearchParams(e) ? (Qe(r, "application/x-www-form-urlencoded;charset=utf-8"), e.toString()) : b.isObject(e) || r && r["Content-Type"] === "application/json" ? (Qe(r, "application/json"), lc(e)) : e;
  }],
  transformResponse: [function(e) {
    var r = this.transitional || mt.transitional, n = r && r.silentJSONParsing, a = r && r.forcedJSONParsing, s = !n && this.responseType === "json";
    if (s || a && b.isString(e) && e.length)
      try {
        return JSON.parse(e);
      } catch (o) {
        if (s)
          throw o.name === "SyntaxError" ? ic(o, this, "E_JSON_PARSE") : o;
      }
    return e;
  }],
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
b.forEach(["delete", "get", "head"], function(e) {
  mt.headers[e] = {};
});
b.forEach(["post", "put", "patch"], function(e) {
  mt.headers[e] = b.merge(cc);
});
var oe = mt, dc = w, pc = oe, fc = function(e, r, n) {
  var a = this || pc;
  return dc.forEach(n, function(o) {
    e = o.call(a, e, r);
  }), e;
}, Rt, tr;
function Jr() {
  return tr || (tr = 1, Rt = function(e) {
    return !!(e && e.__CANCEL__);
  }), Rt;
}
var er = w, Ut = fc, hc = Jr(), mc = oe, gc = ht();
function It(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted)
    throw new gc("canceled");
}
var bc = function(e) {
  It(e), e.headers = e.headers || {}, e.data = Ut.call(
    e,
    e.data,
    e.headers,
    e.transformRequest
  ), e.headers = er.merge(
    e.headers.common || {},
    e.headers[e.method] || {},
    e.headers
  ), er.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(a) {
      delete e.headers[a];
    }
  );
  var r = e.adapter || mc.adapter;
  return r(e).then(function(a) {
    return It(e), a.data = Ut.call(
      e,
      a.data,
      a.headers,
      e.transformResponse
    ), a;
  }, function(a) {
    return hc(a) || (It(e), a && a.response && (a.response.data = Ut.call(
      e,
      a.response.data,
      a.response.headers,
      e.transformResponse
    ))), Promise.reject(a);
  });
}, _ = w, Kr = function(e, r) {
  r = r || {};
  var n = {};
  function a(d, c) {
    return _.isPlainObject(d) && _.isPlainObject(c) ? _.merge(d, c) : _.isPlainObject(c) ? _.merge({}, c) : _.isArray(c) ? c.slice() : c;
  }
  function s(d) {
    if (_.isUndefined(r[d])) {
      if (!_.isUndefined(e[d]))
        return a(void 0, e[d]);
    } else
      return a(e[d], r[d]);
  }
  function o(d) {
    if (!_.isUndefined(r[d]))
      return a(void 0, r[d]);
  }
  function i(d) {
    if (_.isUndefined(r[d])) {
      if (!_.isUndefined(e[d]))
        return a(void 0, e[d]);
    } else
      return a(void 0, r[d]);
  }
  function u(d) {
    if (d in r)
      return a(e[d], r[d]);
    if (d in e)
      return a(void 0, e[d]);
  }
  var l = {
    url: o,
    method: o,
    data: o,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: u
  };
  return _.forEach(Object.keys(e).concat(Object.keys(r)), function(c) {
    var y = l[c] || s, f = y(c);
    _.isUndefined(f) && y !== u || (n[c] = f);
  }), n;
}, Lt, rr;
function Vr() {
  return rr || (rr = 1, Lt = {
    version: "0.26.1"
  }), Lt;
}
var vc = Vr().version, ce = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(t, e) {
  ce[t] = function(n) {
    return typeof n === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
var nr = {};
ce.transitional = function(e, r, n) {
  function a(s, o) {
    return "[Axios v" + vc + "] Transitional option '" + s + "'" + o + (n ? ". " + n : "");
  }
  return function(s, o, i) {
    if (e === !1)
      throw new Error(a(o, " has been removed" + (r ? " in " + r : "")));
    return r && !nr[o] && (nr[o] = !0, console.warn(
      a(
        o,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), e ? e(s, o, i) : !0;
  };
};
function yc(t, e, r) {
  if (typeof t != "object")
    throw new TypeError("options must be an object");
  for (var n = Object.keys(t), a = n.length; a-- > 0; ) {
    var s = n[a], o = e[s];
    if (o) {
      var i = t[s], u = i === void 0 || o(i, s, t);
      if (u !== !0)
        throw new TypeError("option " + s + " must be " + u);
      continue;
    }
    if (r !== !0)
      throw Error("Unknown option " + s);
  }
}
var wc = {
  assertOptions: yc,
  validators: ce
}, Xr = w, _c = Hr, ar = Xo, sr = bc, gt = Kr, Yr = wc, B = Yr.validators;
function nt(t) {
  this.defaults = t, this.interceptors = {
    request: new ar(),
    response: new ar()
  };
}
nt.prototype.request = function(e, r) {
  typeof e == "string" ? (r = r || {}, r.url = e) : r = e || {}, r = gt(this.defaults, r), r.method ? r.method = r.method.toLowerCase() : this.defaults.method ? r.method = this.defaults.method.toLowerCase() : r.method = "get";
  var n = r.transitional;
  n !== void 0 && Yr.assertOptions(n, {
    silentJSONParsing: B.transitional(B.boolean),
    forcedJSONParsing: B.transitional(B.boolean),
    clarifyTimeoutError: B.transitional(B.boolean)
  }, !1);
  var a = [], s = !0;
  this.interceptors.request.forEach(function(f) {
    typeof f.runWhen == "function" && f.runWhen(r) === !1 || (s = s && f.synchronous, a.unshift(f.fulfilled, f.rejected));
  });
  var o = [];
  this.interceptors.response.forEach(function(f) {
    o.push(f.fulfilled, f.rejected);
  });
  var i;
  if (!s) {
    var u = [sr, void 0];
    for (Array.prototype.unshift.apply(u, a), u = u.concat(o), i = Promise.resolve(r); u.length; )
      i = i.then(u.shift(), u.shift());
    return i;
  }
  for (var l = r; a.length; ) {
    var d = a.shift(), c = a.shift();
    try {
      l = d(l);
    } catch (y) {
      c(y);
      break;
    }
  }
  try {
    i = sr(l);
  } catch (y) {
    return Promise.reject(y);
  }
  for (; o.length; )
    i = i.then(o.shift(), o.shift());
  return i;
};
nt.prototype.getUri = function(e) {
  return e = gt(this.defaults, e), _c(e.url, e.params, e.paramsSerializer).replace(/^\?/, "");
};
Xr.forEach(["delete", "get", "head", "options"], function(e) {
  nt.prototype[e] = function(r, n) {
    return this.request(gt(n || {}, {
      method: e,
      url: r,
      data: (n || {}).data
    }));
  };
});
Xr.forEach(["post", "put", "patch"], function(e) {
  nt.prototype[e] = function(r, n, a) {
    return this.request(gt(a || {}, {
      method: e,
      url: r,
      data: n
    }));
  };
});
var Sc = nt, kt, ir;
function $c() {
  if (ir)
    return kt;
  ir = 1;
  var t = ht();
  function e(r) {
    if (typeof r != "function")
      throw new TypeError("executor must be a function.");
    var n;
    this.promise = new Promise(function(o) {
      n = o;
    });
    var a = this;
    this.promise.then(function(s) {
      if (!!a._listeners) {
        var o, i = a._listeners.length;
        for (o = 0; o < i; o++)
          a._listeners[o](s);
        a._listeners = null;
      }
    }), this.promise.then = function(s) {
      var o, i = new Promise(function(u) {
        a.subscribe(u), o = u;
      }).then(s);
      return i.cancel = function() {
        a.unsubscribe(o);
      }, i;
    }, r(function(o) {
      a.reason || (a.reason = new t(o), n(a.reason));
    });
  }
  return e.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, e.prototype.subscribe = function(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }, e.prototype.unsubscribe = function(n) {
    if (!!this._listeners) {
      var a = this._listeners.indexOf(n);
      a !== -1 && this._listeners.splice(a, 1);
    }
  }, e.source = function() {
    var n, a = new e(function(o) {
      n = o;
    });
    return {
      token: a,
      cancel: n
    };
  }, kt = e, kt;
}
var qt, or;
function Tc() {
  return or || (or = 1, qt = function(e) {
    return function(n) {
      return e.apply(null, n);
    };
  }), qt;
}
var Dt, cr;
function Ec() {
  if (cr)
    return Dt;
  cr = 1;
  var t = w;
  return Dt = function(r) {
    return t.isObject(r) && r.isAxiosError === !0;
  }, Dt;
}
var ur = w, Cc = Nr, ut = Sc, Ac = Kr, xc = oe;
function Zr(t) {
  var e = new ut(t), r = Cc(ut.prototype.request, e);
  return ur.extend(r, ut.prototype, e), ur.extend(r, e), r.create = function(a) {
    return Zr(Ac(t, a));
  }, r;
}
var C = Zr(xc);
C.Axios = ut;
C.Cancel = ht();
C.CancelToken = $c();
C.isCancel = Jr();
C.VERSION = Vr().version;
C.all = function(e) {
  return Promise.all(e);
};
C.spread = Tc();
C.isAxiosError = Ec();
ae.exports = C;
ae.exports.default = C;
(function(t) {
  t.exports = ae.exports;
})(Dr);
const Oc = /* @__PURE__ */ Uo(Dr.exports);
class Pc extends Error {
  constructor(e, r = 400, n) {
    super(e), this.status = r, this.data = n;
  }
}
const jc = (t) => t.data, Rc = (t) => {
  var s;
  const e = t.response ? (s = t.response.data) == null ? void 0 : s.message : t.message, r = t.response ? t.response.data : {}, n = t.response ? t.response.status : 400;
  throw new Pc(e, n, r);
}, Uc = (t) => t.then((e) => jc(e)).catch(Rc);
class Ic {
  constructor(e) {
    this.instance = Oc.create(this.mapConfig(e));
  }
  mapConfig(e) {
    const r = {};
    return e.baseURL && (r.baseURL = e.baseURL), e.headers && (r.headers = e.headers), typeof e.withCredentials == "boolean" && (r.withCredentials = e.withCredentials), r;
  }
  mapRequestOptions(e) {
    const r = {};
    return e.headers && (r.headers = e.headers), e.responseType && (r.responseType = e.responseType), e.method && (r.method = e.method), e.url && (r.url = e.url), e.data && (r.data = e.data), e.params && (r.params = e.params), r;
  }
  setHeaders(e = {}, r = !1) {
    r ? this.instance.defaults.headers.common = e : this.instance.defaults.headers.common = {
      ...this.instance.defaults.headers.common,
      ...e
    };
  }
  setInterceptHeaders(e) {
    this.instance.interceptors.request.use(
      (r) => (r.headers = e(r.headers), r),
      function(r) {
        return Promise.reject(r);
      }
    );
  }
  handleRequest(e) {
    return Uc(
      this.instance.request(this.mapRequestOptions(e))
    );
  }
  get(e, r, n = {}) {
    return this.handleRequest({
      method: "get",
      url: e,
      params: r,
      ...n
    });
  }
  post(e, r, n = {}) {
    return this.handleRequest({
      method: "post",
      url: e,
      data: r,
      ...n
    });
  }
  put(e, r, n = {}) {
    return this.handleRequest({
      method: "put",
      url: e,
      data: r,
      ...n
    });
  }
  patch(e, r, n = {}) {
    return this.handleRequest({
      method: "patch",
      url: e,
      data: r,
      ...n
    });
  }
  delete(e, r, n = {}) {
    return this.handleRequest({
      method: "delete",
      url: e,
      data: r,
      ...n
    });
  }
}
class at {
  byDriver(e, r) {
    switch (e) {
      case "axios":
        return new Ic(r);
      default:
        throw new Error("Unsupported HttpClient: " + e);
    }
  }
  default(e = {}) {
    const r = rt();
    return this.byDriver(r.get().httpClient, e);
  }
}
const Gt = (t = null) => {
  const e = rt().get().services.identity.pk;
  return t || (e !== "please_set_this" ? e : "");
}, Wt = {}, Qr = (t) => Wt[t] || null, Lc = () => Qr("connect"), tn = (t) => new URLSearchParams(
  Object.entries(t).reduce((e, [r, n]) => n === void 0 ? e : r === "forceVerify" ? { ...e, force_verify: n ? "true" : "false" } : r === "suggestedName" ? { ...e, suggested_name: n } : r === "suggestedEmail" ? { ...e, suggested_email: n } : { ...e, [r]: n }, {})
).toString(), en = (t, e, r = 858) => new Promise((n, a) => {
  const s = new URL(t).origin, o = t, i = Math.min(600, window.innerWidth), u = Math.min(r, window.innerHeight), l = (window.innerWidth - i) / 2, d = (window.innerHeight - u) / 4, c = {
    toolbar: "no",
    location: "no",
    directories: "no",
    status: "no",
    menubar: "no",
    scrollbars: "no",
    resizable: "no",
    copyhistory: "no",
    width: i,
    height: u,
    top: d,
    left: l
  }, y = Object.keys(c).reduce(
    (g, v) => [
      ...g,
      `${v}=${c[v]}`
    ],
    []
  ).join(","), f = window.open(t, o, y);
  f && (Wt[e] = f), setTimeout(() => {
    (f == null ? void 0 : f.focus) && !f.closed && (f == null || f.focus());
  }, 10);
  const $ = (g) => {
    g.origin === s && g.data.source === e && n(g.data.data);
  }, T = window.setInterval(() => {
    (!f || f.closed) && (window.clearInterval(T), window.removeEventListener("message", $, !1), a("popout closed"), delete Wt[e]);
  }, 250);
  window.addEventListener("message", $, !1);
}), kc = ({
  pk: t,
  ...e
}) => {
  const {
    services: {
      identity: { pk: r }
    },
    domains: { identity: n }
  } = rt().get(), a = `${n}/connect/${t || r}?${tn(
    e
  )}`;
  return en(
    a,
    "connect",
    e.intent === "upgrade" ? 670 : 724
  );
}, qc = (t) => {
  const {
    domains: { identity: e }
  } = rt().get(), r = `${e}/redirect/?${tn(t)}`;
  return en(
    r,
    t.view
  );
};
class bt {
  constructor(e, r) {
    this.prefix = "", this.version = "", this.client = r, this.version = e, this.init();
  }
  init() {
  }
  setClientIdInterceptor() {
    this.client.setInterceptHeaders((e) => {
      const r = Gt(), n = {
        ...e || {}
      };
      return r && (n["Client-ID"] = r), n;
    });
  }
  get base() {
    return `${this.version ? `/${this.version}` : ""}${this.prefix}`;
  }
}
class Dc extends bt {
  constructor() {
    super(...arguments), this.prefix = "/auth";
  }
  init() {
    this.setClientIdInterceptor();
  }
  emailLogin(e) {
    return this.client.post(`${this.base}/login`, e);
  }
  emailSignup(e) {
    var r;
    return e.locale === void 0 && (e.locale = ((r = window == null ? void 0 : window.navigator) == null ? void 0 : r.language) || "en-US"), this.client.post(`${this.base}/register`, e);
  }
  logout() {
    return this.client.post(`${this.base}/logout`, {}).then(() => {
    });
  }
  forgotPassword(e) {
    return this.client.post(`${this.base}/password/reset/request`, {
      email: e
    });
  }
  changePassword(e, r, n) {
    return this.client.post(`${this.base}/change-password`, {
      current_password: e,
      new_password: r,
      new_password_confirmation: n
    }).then(() => {
    });
  }
  resetPassword(e, r, n, a = "") {
    return this.client.post(`${this.base}/password/reset/confirm`, {
      email: e,
      code: r,
      new_password: n,
      tfa_code: a
    });
  }
  generateTfa() {
    return this.client.post(`${this.base}/tfa/generate`, {});
  }
  confirmTfa(e) {
    return this.client.post(`${this.base}/tfa/confirm`, { tfa_code: e });
  }
  checkTfa(e, r = !1) {
    return this.client.post(`${this.base}/tfa/check`, { tfa_code: e, remember: r }).then(() => {
    });
  }
  removeTfa(e) {
    return this.client.post(`${this.base}/tfa/disable`, { tfa_code: e }).then(() => {
    });
  }
  getLocaleInfo() {
    return this.client.get(`${this.base}/locale`, {}).then((e) => ({
      ...e,
      ageGate: {
        required: e.ageGating.required,
        minAge: e.ageGating.minimumAge
      }
    }));
  }
}
class Nc extends bt {
  constructor() {
    super(...arguments), this.prefix = "/users";
  }
  init() {
    this.setClientIdInterceptor();
  }
  getAuthUser() {
    return this.client.get(`${this.base}/@me`, {});
  }
  verifyEmailRequest() {
    return this.client.post(`${this.base}/@me/email/verification/request`, {}).then(() => {
    });
  }
  verifyEmailConfirm(e, r, n = "") {
    return this.client.post(`${this.base}/@me/email/verification/confirm`, {
      code: e,
      email: r,
      tfa_code: n
    }).then(() => {
    });
  }
  getConnections() {
    return this.client.get(`${this.base}/@me/connections`, {});
  }
  getSessions() {
    return this.client.get(`${this.base}/@me/sessions`, {});
  }
  deleteSession(e) {
    return this.client.delete(`${this.base}/@me/sessions/${e}`);
  }
  deleteAllSessions() {
    return this.client.delete(`${this.base}/@me/sessions`);
  }
  getSubscription() {
    return this.client.get(
      `${this.base}/@me/subscriptions/ultra`,
      {}
    ).then((e) => {
      if (!(e != null && e.id))
        throw new Error("Subscription response was not valid");
      return e;
    });
  }
  requestChangeEmail({
    password: e,
    to_email: r
  }) {
    return this.client.post(`${this.base}/@me/email/change/request`, {
      password: e,
      new_email: r
    }).then(() => null);
  }
  confirmChangeEmail({
    password: e,
    code: r,
    to_email: n
  }) {
    return this.client.post(`${this.base}/@me/email/change/confirm`, {
      password: e,
      new_email: n,
      code: r
    }).then(() => null);
  }
}
class Mc extends bt {
  constructor() {
    super(...arguments), this.prefix = "/identity";
  }
  authorizeClient(e, r = !1, n = "") {
    const a = Gt(n);
    return this.client.get(`${this.base}/clients/${a}`, {
      origin: e,
      force_verify: r
    });
  }
  connectIdentity({
    pk: e = void 0,
    ...r
  }) {
    const n = Gt(e);
    return this.client.post(`${this.base}/clients/${n}/oauth2`, r);
  }
}
let V = null, st = [];
const rn = (t) => t.map(
  ({ company_id: e, logo_thumbnail: r, logo_full: n, ...a }) => ({
    id: e,
    logoThumb: r,
    logoFull: n,
    ...a
  })
), nn = () => rn([
  {
    company_id: "streamlabs",
    name: "Streamlabs",
    url: "https://streamlabs.com",
    logo_full: "https://cdn.streamlabs.com/static/imgs/identity/streamlabs-logo-full.jpg",
    logo_thumbnail: "https://cdn.streamlabs.com/static/imgs/identity/streamlabs-logo-thumb.png"
  },
  {
    company_id: "willow",
    name: "Link Space",
    url: "https://link.space",
    logo_full: "https://cdn.streamlabs.com/static/imgs/identity/link-space-logo-full.png?1689016443815",
    logo_thumbnail: "https://cdn.streamlabs.com/static/imgs/identity/link-space-logo-thumb.png?1689016443815"
  },
  {
    company_id: "crossclip",
    name: "Cross Clip",
    url: "https://crossclip.streamlabs.com",
    logo_full: "https://cdn.streamlabs.com/static/imgs/identity/cross-clip-logo-full.png?1686780068486",
    logo_thumbnail: "https://cdn.streamlabs.com/static/imgs/identity/cross-clip-logo-thumb.png?1686780068486"
  },
  {
    company_id: "oslo",
    name: "Video Editor",
    url: "https://videoeditor.streamlabs.com",
    logo_full: "https://cdn.streamlabs.com/static/imgs/identity/video-editor-full.png?1686780068486",
    logo_thumbnail: "https://cdn.streamlabs.com/static/imgs/identity/video-editor-logo-thumb.png?1686780068486"
  },
  {
    company_id: "melon",
    name: "Talk Studio",
    url: "https://talkstudio.streamlabs.com",
    logo_full: "https://cdn.streamlabs.com/static/imgs/identity/talk-studio-logo-full.png?1686780068486",
    logo_thumbnail: "https://cdn.streamlabs.com/static/imgs/identity/talk-studio-logo-thumb.png?1686780068486"
  },
  {
    company_id: "studio",
    name: "Console",
    url: "https://console.streamlabs.com",
    logo_full: "https://cdn.streamlabs.com/static/imgs/identity/console-logo-full.png?1686780068486",
    logo_thumbnail: "https://cdn.streamlabs.com/static/imgs/identity/console-logo-thumb.png?1686780068486"
  },
  {
    company_id: "mevo",
    name: "Mevo",
    url: "https://mevo.com",
    logo_full: "https://cdn.streamlabs.com/static/imgs/identity/mevo-logo-full.png",
    logo_thumbnail: "https://cdn.streamlabs.com/static/imgs/identity/mevo-logo-full.png"
  },
  {
    company_id: "typestudio",
    name: "Podcast Editor",
    url: "https://streamlabs.com/podcast-editor",
    logo_full: "https://cdn.streamlabs.com/static/imgs/identity/podcast-editor-logo-full.png?1686780068486",
    logo_thumbnail: "https://cdn.streamlabs.com/static/imgs/identity/podcast-editor-logo-thumb.png?1686780068486"
  }
]), an = async () => {
  if (st.length > 0)
    return st;
  const t = R();
  V || (V = t.api.data.getCompanies());
  try {
    return st = await V, V = null, st;
  } catch (e) {
    return console.warn(
      "failed to get companies",
      e.message
    ), V = null, [...nn()];
  }
}, Fc = async (t) => (await an()).find((e) => e.id === t);
let X = null;
const x = {
  companyID: "",
  lang: "",
  apps: []
}, sn = (t) => t.map(
  ({
    company_id: e,
    app_id: r,
    name: n,
    name_short: a,
    url: s,
    logo_thumbnail: o,
    description: i
  }) => ({
    id: r,
    companyId: e,
    logoThumb: o,
    nameShort: a,
    name: n,
    url: s,
    description: i
  })
), on = () => sn([
  {
    app_id: "totalCreator",
    company_id: "streamlabs",
    name: "Total Creator",
    name_short: "Total Creator",
    url: "https://streamlabs.com/total-creator",
    logo_thumbnail: "https://cdn.streamlabs.com/static/imgs/identity/app-thumb-total-creator.png",
    description: ""
  },
  {
    app_id: "cloudbot",
    company_id: "streamlabs",
    name: "CloudBot",
    name_short: "CloudBot",
    url: "https://streamlabs.com/dashboard/cloudbot",
    logo_thumbnail: "https://cdn.streamlabs.com/static/imgs/identity/app-thumb-cloudbot.png",
    description: ""
  },
  {
    app_id: "streamlabsDashboard",
    company_id: "streamlabs",
    name: "Streamlabs Dashboard",
    name_short: "Streamlabs Dashboard",
    url: "https://streamlabs.com/dashboard",
    logo_thumbnail: "https://cdn.streamlabs.com/static/imgs/identity/app-thumb-streamlabs-web.png",
    description: ""
  },
  {
    app_id: "streamlabsDesktop",
    company_id: "streamlabs",
    name: "Streamlabs Desktop",
    name_short: "Streamlabs Desktop",
    url: "https://streamlabs.com",
    logo_thumbnail: "https://cdn.streamlabs.com/static/imgs/identity/app-thumb-streamlabs-obs.png",
    description: ""
  },
  {
    app_id: "alerts",
    company_id: "streamlabs",
    name: "Alerts",
    name_short: "Alerts",
    url: "https://streamlabs.com/dashboard/alerts",
    logo_thumbnail: "https://cdn.streamlabs.com/static/imgs/identity/app-thumb-alerts.png",
    description: ""
  },
  {
    app_id: "merchStore",
    company_id: "streamlabs",
    name: "Merch Store",
    name_short: "Merch Store",
    url: "https://streamlabs.com/dashboard/merch",
    logo_thumbnail: "https://cdn.streamlabs.com/static/imgs/identity/app-thumb-merch-store.png",
    description: ""
  },
  {
    app_id: "tipPage",
    company_id: "streamlabs",
    name: "Tip Page",
    name_short: "Tip Page",
    url: "https://streamlabs.com/dashboard/tips",
    logo_thumbnail: "https://cdn.streamlabs.com/static/imgs/identity/app-thumb-tip-page.png",
    description: ""
  },
  {
    app_id: "multiStream",
    company_id: "streamlabs",
    name: "MultiStream",
    name_short: "MultiStream",
    url: "https://streamlabs.com/multistream",
    logo_thumbnail: "https://cdn.streamlabs.com/static/imgs/identity/app-thumb-multistream.png",
    description: ""
  },
  {
    app_id: "themeLibrary",
    company_id: "streamlabs",
    name: "Theme Library",
    name_short: "Theme Library",
    url: "https://streamlabs.com/themes",
    logo_thumbnail: "https://cdn.streamlabs.com/static/imgs/identity/app-thumb-theme-library.png",
    description: ""
  },
  {
    app_id: "logoMaker",
    company_id: "streamlabs",
    name: "Logo Maker",
    name_short: "Logo Maker",
    url: "https://streamlabs.com/dashboard/logo-maker",
    logo_thumbnail: "https://cdn.streamlabs.com/static/imgs/identity/app-thumb-logo-maker.png",
    description: ""
  },
  {
    app_id: "introMaker",
    company_id: "streamlabs",
    name: "Intro Maker",
    name_short: "Intro Maker",
    url: "https://streamlabs.com/dashboard/intro-maker",
    logo_thumbnail: "https://cdn.streamlabs.com/static/imgs/identity/app-thumb-intro-maker.png",
    description: ""
  },
  {
    app_id: "streamWidgets",
    company_id: "streamlabs",
    name: "Stream Widgets",
    name_short: "Stream Widgets",
    url: "https://streamlabs.com/dashboard#/widgets",
    logo_thumbnail: "https://cdn.streamlabs.com/static/imgs/identity/app-thumb-stream-widgets.png",
    description: ""
  },
  {
    app_id: "appStore",
    company_id: "streamlabs",
    name: "App Store",
    name_short: "App Store",
    url: "https://platform.streamlabs.com/app-store",
    logo_thumbnail: "https://cdn.streamlabs.com/static/imgs/identity/app-thumb-app-store.png",
    description: ""
  }
]), cn = async (t, e = "en-US") => {
  if (x.companyID === t && x.lang === e && x.apps.length > 0)
    return x.apps;
  const r = R();
  X || (X = r.api.data.getApps(t, e));
  try {
    return x.companyID = t, x.lang = e, x.apps = await X, X = null, x.apps;
  } catch (n) {
    return console.warn(
      "failed to get apps",
      n.message
    ), X = null, [...on()];
  }
}, Bc = async (t, e, r = "en-US") => (await cn(e, r)).find((n) => n.id === t);
class Hc extends bt {
  constructor() {
    super(...arguments), this.prefix = "";
  }
  getCompanies() {
    return this.client.get(`${this.base}/companies`, {}).then(rn);
  }
  getApps(e, r) {
    return this.client.get(`${this.base}/apps`, { companyId: e, lang: r }).then(sn);
  }
  getPlans(e = "USD") {
    return this.client.get(`${this.base}/subscriptions/plans`, {
      currency: e
    });
  }
  async getToken(e, r) {
    const {
      services: {
        identity: { pk: n }
      }
    } = rt().get();
    return this.client.post(
      `${this.base}/clients/${r || n}/ultra/${e}`,
      {}
    ).then(({ redirect_url: a }) => this.client.post(a, {})).then(({ token: a }) => ({
      token: a,
      client_id: r || n
    }));
  }
}
let Jt = null;
const R = () => {
  if (!Jt)
    throw new Error(
      "FeSdk class needs to be initiated for global status, before calling getGlobalFeSdk()"
    );
  return Jt;
};
class zc {
  constructor(e, r = !1) {
    this.env = e, this.api = {
      auth: this.getAuthService(),
      user: this.getUserService(),
      identity: this.getIdentityService(),
      data: this.getDataService()
    }, r && (Jt = this);
  }
  setEnv(e) {
    this.env = e, this.api = {
      auth: this.getAuthService(),
      user: this.getUserService(),
      identity: this.getIdentityService(),
      data: this.getDataService()
    };
  }
  getIdentityService() {
    const {
      identity: { domain: e, version: r }
    } = this.env.get().services, n = new at().default({
      baseURL: e,
      withCredentials: !0
    });
    return new Mc(
      r,
      n
    );
  }
  getAuthService() {
    const {
      auth: { domain: e, version: r }
    } = this.env.get().services, n = new at().default({
      withCredentials: !0,
      baseURL: e
    });
    return new Dc(r, n);
  }
  getUserService() {
    const {
      user: { domain: e, version: r }
    } = this.env.get().services, n = new at().default({
      baseURL: e,
      withCredentials: !0
    });
    return new Nc(r, n);
  }
  getDataService() {
    const {
      data: { domain: e, version: r }
    } = this.env.get().services, n = new at().default({
      baseURL: e,
      withCredentials: !0
    });
    return new Hc(r, n);
  }
}
let Y = null;
const it = {}, un = () => [
  {
    id: 1,
    tag: "ultra",
    gateway_id: "bt_uSQFq7KonV",
    price: 19,
    currency: "USD",
    period: "month",
    frequency: 1
  },
  {
    id: 2,
    tag: "ultra",
    gateway_id: "bt_uSQFq7KonV",
    price: 149,
    currency: "USD",
    period: "year",
    frequency: 12
  },
  {
    id: 3,
    tag: "ultra",
    gateway_id: "stripe_9PpSvOxbLg",
    price: 19,
    currency: "USD",
    period: "month",
    frequency: 1
  },
  {
    id: 4,
    tag: "ultra",
    gateway_id: "stripe_9PpSvOxbLg",
    price: 149,
    currency: "USD",
    period: "year",
    frequency: 12
  }
], ln = async (t = "USD") => {
  if (it[t])
    return it[t];
  const e = R();
  Y || (Y = e.api.data.getPlans(t).then(({ plans: r }) => r));
  try {
    return it[t] = (await Y).map((r) => ({
      ...r,
      price: r.price / 100
    })), Y = null, it[t];
  } catch (r) {
    return console.warn(
      "failed to get plans",
      r.message
    ), Y = null, [...un()];
  }
}, Gc = async (t, e = "USD") => (await ln(e)).find((r) => r.period === t), ue = (t, e) => {
  const n = R().env.get().domains.ultra, a = new URL(n);
  return a.pathname = t, Object.entries(e).forEach(([s, o]) => {
    a.searchParams.set(s, o);
  }), a.toString();
}, Wc = async (t) => {
  const r = await R().api.data.getToken("subscribe", t);
  return { redirect_url: ue("checkout", r) };
}, Jc = async (t) => {
  const r = await R().api.data.getToken("unsubscribe", t);
  return { redirect_url: ue("cancel", r) };
}, Kc = async (t) => {
  const r = await R().api.data.getToken("payment-method", t);
  return { redirect_url: ue("payment-method", r) };
}, Vc = ({
  w: t,
  viewOrigin: e,
  popout: r,
  source: n,
  callback: a,
  onSuccess: s,
  onClose: o
}) => {
  if (!r)
    throw new Error("No popout window given");
  const i = (l) => {
    l.origin === e && l.data.source === n && (a({
      action: l.data.action,
      data: l.data.data
    }), l.data.isExitEvent && (t.removeEventListener("message", i, !1), r == null || r.close(), s(!0)));
  }, u = t.setInterval(() => {
    (!r || r.closed) && (t.clearInterval(u), t.removeEventListener("message", i, !1), o(!1));
  }, 250);
  t.addEventListener("message", i, !1);
}, Xc = () => `
    <html>
      <head>
        <title>Ultra Checkout Loading...</title>
        <style>
          body {
            margin: 0;
            padding: 0;
            background: #f5f8fa;
            font-family: 'Roboto', sans-serif;
          }
          .loading {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100vh;
          }
          .lds-roller {
            display: inline-block;
            position: relative;
            width: 80px;
            height: 80px;
          }
          .lds-roller div {
            animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
            transform-origin: 40px 40px;
          }
          .lds-roller div:after {
            content: " ";
            display: block;
            position: absolute;
            width: 7px;
            height: 7px;
            border-radius: 50%;
            background: #17242d;
            margin: -4px 0 0 -4px;
          }
          .lds-roller div:nth-child(1) {
            animation-delay: -0.036s;
          }
          .lds-roller div:nth-child(1):after {
            top: 63px;
            left: 63px;
          }
          .lds-roller div:nth-child(2) {
            animation-delay: -0.072s;
          }
          .lds-roller div:nth-child(2):after {
            top: 68px;
            left: 56px;
          }
          .lds-roller div:nth-child(3) {
            animation-delay: -0.108s;
          }
          .lds-roller div:nth-child(3):after {
            top: 71px;
            left: 48px;
          }
          .lds-roller div:nth-child(4) {
            animation-delay: -0.144s;
          }
          .lds-roller div:nth-child(4):after {
            top: 72px;
            left: 40px;
          }
          .lds-roller div:nth-child(5) {
            animation-delay: -0.18s;
          }
          .lds-roller div:nth-child(5):after {
            top: 71px;
            left: 32px;
          }
          .lds-roller div:nth-child(6) {
            animation-delay: -0.216s;
          }
          .lds-roller div:nth-child(6):after {
            top: 68px;
            left: 24px;
          }
          .lds-roller div:nth-child(7) {
            animation-delay: -0.252s;
          }
          .lds-roller div:nth-child(7):after {
            top: 63px;
            left: 17px;
          }
          .lds-roller div:nth-child(8) {
            animation-delay: -0.288s;
          }
          .lds-roller div:nth-child(8):after {
            top: 56px;
            left: 12px;
          }
          @keyframes lds-roller {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }

        </style>
      </head>
      <body>
        <div class="loading">
          <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        <div>
      </body>
    </html>`, le = async (t) => {
  const e = t.initialWidth, r = t.initialHeight, n = (window.innerWidth - e) / 2, a = (window.innerHeight - r) / 4, s = {
    toolbar: "no",
    location: "no",
    directories: "no",
    status: "no",
    menubar: "no",
    scrollbars: "no",
    resizable: "no",
    copyhistory: "no",
    width: e,
    height: r,
    top: a,
    left: n
  }, o = Object.keys(s).reduce(
    (d, c) => [
      ...d,
      `${c}=${s[c]}`
    ],
    []
  ).join(","), i = window.open(
    typeof t.url == "object" ? "Loading Ultra Checkout..." : t.url,
    "ultra-checkout",
    o
  );
  if (!i)
    throw new Error("Failed to open checkout window");
  i.document.write(Xc()), setTimeout(() => {
    (i == null ? void 0 : i.focus) && !i.closed && (i == null || i.focus());
  }, 10);
  const u = typeof t.url == "object" ? await t.url : t.url;
  i.location.href = u;
  const l = new URL(u).origin;
  return new Promise((d, c) => {
    Vc({
      w: window,
      viewOrigin: l,
      popout: i,
      source: t.source,
      callback: t.callback,
      onSuccess: d,
      onClose: c
    });
  });
}, Yc = async ({
  url: t,
  initialHeight: e = 966,
  initialWidth: r = 680,
  source: n = "sl-ultra",
  onSetHeight: a,
  onLogin: s,
  onSwitchUser: o,
  onSubscribed: i
}) => le({
  url: t,
  initialHeight: e,
  initialWidth: r,
  source: n,
  callback: (l) => {
    switch (l.action) {
      case "setHeight":
        typeof a == "function" && a(l.data);
        break;
      case "login":
        s(l.data);
        break;
      case "switch":
        o(l.data);
        break;
      case "userSubscribed":
        i(l.data);
        break;
      default:
        throw new Error(
          "Unexpected action: " + { ...l }.action
        );
    }
  }
}), Zc = async ({
  url: t,
  initialHeight: e = 522,
  initialWidth: r = 680,
  source: n = "sl-ultra",
  onSetHeight: a,
  onLogin: s,
  onSwitchUser: o,
  onCancel: i,
  onUnsubscribed: u
}) => le({
  url: t,
  initialHeight: e,
  initialWidth: r,
  source: n,
  callback: (d) => {
    switch (d.action) {
      case "setHeight":
        typeof a == "function" && a(d.data);
        break;
      case "login":
        s(d.data);
        break;
      case "switch":
        o(d.data);
        break;
      case "userCanceled":
        i(d.data);
        break;
      case "userUnsubscribed":
        u(d.data);
        break;
      default:
        throw new Error(
          "Unexpected action: " + { ...d }.action
        );
    }
  }
}), Qc = async ({
  url: t,
  initialHeight: e = 1205,
  initialWidth: r = 680,
  source: n = "sl-ultra",
  onSetHeight: a,
  onLogin: s,
  onPaymentUpdated: o
}) => le({
  url: t,
  initialHeight: e,
  initialWidth: r,
  source: n,
  callback: (u) => {
    switch (u.action) {
      case "setHeight":
        typeof a == "function" && a(u.data);
        break;
      case "login":
        s(u.data);
        break;
      case "paymentUpdated":
        o(u.data);
        break;
      default:
        throw new Error(
          "Unexpected action: " + { ...u }.action
        );
    }
  }
}), tu = () => [
  {
    name: "Google Authenticator",
    url: "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
  },
  { name: "Authy", url: "https://authy.com" },
  {
    name: "Microsoft Authenticator",
    url: "https://www.microsoft.com/en-us/security/mobile-authenticator-app"
  }
], eu = (t, e, r) => {
  var s;
  if (r)
    return r;
  const a = R().env.get().links;
  return a[t] ? (s = a[t]) == null ? void 0 : s[e] : a[e];
}, nu = {
  getApps: cn,
  getAppById: Bc,
  getFallbackApps: on,
  getCompanies: an,
  getCompanyById: Fc,
  getFallbackCompanies: nn,
  getAuthenticatorApps: tu,
  connect: kc,
  openView: qc,
  getConnectWindow: Lc,
  getWindowBySource: Qr,
  getPlans: ln,
  getFallbackPlans: un,
  getPlanByPeriod: Gc,
  getUltraUnsubscribeUrl: Jc,
  getUltraSubscribeUrl: Wc,
  getPaymentMethodUrl: Kc,
  openUltraSubscribePopout: Yc,
  openUltraUnsubscribePopout: Zc,
  openUltraPaymentMethodPopout: Qc,
  getCompanyLink: eu
}, ru = new zc(
  qr("production", {}),
  !0
), au = (t, e = {}) => {
  ru.setEnv(qr(t, e));
};
export {
  Pc as ApiError,
  ru as default,
  nu as methods,
  au as setEnvironment
};
